import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLightboxState } from "yet-another-react-lightbox/core";
import { photos } from "../../../assets/photos";

export const DownloadButton = () => {
  const {
    state: { currentIndex },
  } = useLightboxState();

  const [downlaodUrl, setDownloadUrl] = useState(null);
  const location = useLocation();

  const getDownloadUrl = () => {
    const finder = photos.filter((e, i) => {
      return `/${e.type}` === location.pathname;
    });

    const found = finder[currentIndex];
    if (found?.download) return found?.download;
    return null;
  };

  useEffect(() => {
    setDownloadUrl(getDownloadUrl());
  }, [currentIndex]);

  if (!downlaodUrl) return null;

  return (
    <a
      href={downlaodUrl}
      className="yarl__button"
      target="_blank"
      rel="noreferrer"
      download
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        aria-hidden="true"
        className="yarl__icon"
      >
        <g fill="currentColor">
          <path d="M0 0h24v24H0z" fill="none"></path>
          <path d="M2.5,14.2c0.3,0,0.6,0.3,0.6,0.6V18c0,0.7,0.6,1.3,1.3,1.3h15.1c0.7,0,1.3-0.6,1.3-1.3v-3.2c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6V18c0,1.4-1.1,2.5-2.5,2.5H4.4c-1.4,0-2.5-1.1-2.5-2.5v-3.2C1.9,14.5,2.2,14.2,2.5,14.2z"></path>
          <path d="M11.6,16.7c0.2,0.2,0.6,0.2,0.9,0c0,0,0,0,0,0l3.8-3.8c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0l-2.7,2.7V3.6C12.6,3.3,12.3,3,12,3c-0.3,0-0.6,0.3-0.6,0.6v11.1L8.7,12c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9L11.6,16.7z"></path>
        </g>
      </svg>
    </a>
  );
};
